import { ForecastError as ApiForecastError } from "../api/client";

export interface ForecastErrorProps {
  error: unknown;
  onRetry?: () => void;
}

export default function ForecastError({ error, onRetry }: ForecastErrorProps) {
  const isLocationUnsupported = error instanceof ApiForecastError && error.status === 404;

  const description = isLocationUnsupported
    ? "The National Weather Service doesn't have forecast data for this location. Try a different one."
    : "The National Weather Service is temporarily unavailable. Check your connection and try again.";

  return (
    <div role="alert" className="flex flex-col gap-3 py-4">
      <div className="flex flex-col gap-3 rounded-xl border border-error bg-[#fff7f7] p-5">
        <h2 className="text-[18px] font-bold text-error">Forecast unavailable</h2>
        <p className="text-[14px] text-on-surface-variant">{description}</p>
        {!isLocationUnsupported && onRetry ? (
          <button
            type="button"
            onClick={onRetry}
            className="self-start rounded-[24px] bg-primary px-5 py-2 text-[14px] font-medium text-on-primary transition-opacity hover:opacity-90"
          >
            Try again
          </button>
        ) : null}
      </div>

      <div className="flex flex-col gap-2 rounded-xl bg-surface-container p-5">
        <h3 className="font-bold text-on-surface">What the user can do</h3>
        <ul className="list-disc space-y-1 pl-5 text-[14px] text-on-surface-variant">
          <li>Verify latitude and longitude are inside the US</li>
          <li>Try the default location again</li>
          <li>Retry when the NWS API is reachable</li>
        </ul>
      </div>
    </div>
  );
}
